import { useSelector } from 'react-redux';
import { getTranslations } from '@client/i18n/redux/redux';
import { getTranslatedText, TranslateFunction } from 'b2b-server/core/utils/language';

export const useTranslate = (): TranslateFunction => {
  const translations = useSelector(getTranslations);

  return (key, params) => getTranslatedText(translations, key, params);
};
